<template>
  <div class="fillcontain" >
    <head-top></head-top>
    <div class="select_container">
      <el-button type="primary" class="el-icon-plus" @click="addtranslate">新增角色</el-button>
    </div>
    <div class="table_container">
      <el-table
        :data="tableData"
        highlight-current-row
        style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          property="name"
          label="角色">
        </el-table-column>
        <el-table-column
          :formatter="formatDate"
          property="updateTime"
          label="注册时间">
        </el-table-column>
        <el-table-column
          width="100"
          fixed="right"
          label="操作">
          <template slot-scope="scope" >
            <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>


<script>
  import headTop from '../components/headTop'
  import { getroleList,getroleDel } from "../api/api"
  export default {
    data () {
      return {
        tableData: [],
        limit: 20,
        total: 0,
        currentPage: 1,
      }
    },
    components: {
      headTop,
    },
    methods:{
      formatDate:function (value){
        var dateee = new Date(value.updateTime).toJSON();
        return new Date(+new Date(dateee)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getroleList()
      },
      // 账号角色列表
      getroleList(){
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
        };
        getroleList(params).then(res=>{
          this.total = res.total
          this.tableData = res.pageInfo
        }).catch(error=>{
          console.log(error);
        })
      },
      // 新增角色权限
      addtranslate(){
        this.$router.push({
          path: 'newprivilege',
        });
      },
      //编辑
      handleEdit(index, row) {
        this.$router.push({
          path: 'modprivilege',
          query:{
            id:row.id,
          }
        });
      },
      handleDelete(index, row){
        //删除
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params={
            id:row.id,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
          };
          getroleDel(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.getroleList()
              this.tableData.splice(index, 1);
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              });
            }
          }).catch(error=>{
            console.log(error)
          })
        }).catch(() => {
        })
      }
    },
    created(){
      this.getroleList()
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';

</style>



// WEBPACK FOOTER //
// src/page/privilege.vue